import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Reviews'] });

const apiReviewsSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getRating: builder.query({
      query: (ean) => `/community/products/${ean}/rating/`,
      providesTags: ['Reviews'],
    }),
    getRatingsByProductList: builder.query({
      query: ({ eans, psize }) => {
        return {
          url: '/community/ratings/',
          params: {
            eans,
            psize,
          },
        };
      },
      providesTags: ['Reviews'],
    }),
    getReviews: builder.query({
      query: ({ ean, mine, page, ordering, psize }) => ({
        url: `/community/products/${ean}/reviews/`,
        params: {
          mine,
          page,
          ordering,
          psize,
        },
      }),
      providesTags: ['Reviews'],
    }),
    addNewReview: builder.mutation({
      query: ({ payload, ean }) => ({
        url: `/community/products/${ean}/reviews/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Reviews'],
    }),
    updateReview: builder.mutation({
      query: ({ payload, ean, reviewId }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Reviews'],
    }),
    deleteReview: builder.mutation({
      query: ({ ean, reviewId }) => ({
        url: `/community/products/${ean}/reviews/${reviewId}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['Reviews'],
    }),
  }),
});

export const { useGetRatingQuery, useGetRatingsByProductListQuery, useGetReviewsQuery, useAddNewReviewMutation, useUpdateReviewMutation, useDeleteReviewMutation } = apiReviewsSlice;

export default apiReviewsSlice;
